<script lang="ts">
	import type { Snippet } from "svelte";
	import type { ClassValue, MouseEventHandler } from "svelte/elements";
	import Formatted from "./common/Formatted.svelte";
	import Heading from "./common/Heading.svelte";

	const {
		title,
		subtitle,
		description,
		children,
		active,
		horizontal,
		class: customClass,
		onclick,
	}: {
		title: string;
		subtitle: string;
		description: string;
		children: Snippet;
		active: boolean;
		horizontal: boolean;
		class?: ClassValue;
		onclick: MouseEventHandler<HTMLButtonElement>;
	} = $props();
</script>

<button
	type="button"
	class={[
		customClass,
		"flex rounded-3xl overflow-hidden text-left",
		!horizontal && "xl:flex-col xl:text-center",
		"border-2 border-fcrlightgray aria-checked:border-fcrdarkgray transition-colors",
	]}
	role="radio"
	aria-checked={active}
	{onclick}
>
	<div
		class={[
			"h-24 md:min-h-29 max-h-40 max-w-40 md:h-full aspect-square shrink-0 relative sm:h-auto sm:w-1/3",
			!horizontal && "xl:h-auto xl:w-full xl:max-w-none",
		]}
		aria-hidden="true"
	>
		{@render children()}
	</div>
	<div class="px-4.5 py-2 sm:py-8 xl:py-4 flex flex-col gap-0.5 md:gap-1.5 grow">
		<Heading level={4} text={title} class="font-antipol text-sm/6 sm:text-lg/tighter text-fcrdarkgray" />
		<div class="text-fcrbrown font-medium uppercase text-[0.6875rem]/none tracking-[0.078125rem] mb-px">
			<Formatted text={subtitle} />
		</div>
		<p class="text-fcrgray text-2xs/none md:text-xs/tighter grow">
			<Formatted text={description} />
		</p>
	</div>
</button>
